import React from 'react';
import { BookOpenIcon, WindIcon, BrainIcon, BedDoubleIcon, PenLineIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function MethodSection() {
  const {
    ref: methodRef,
    isVisible: methodVisible
  } = useScrollReveal();
  const {
    ref: featuresRef,
    isVisible: featuresVisible
  } = useScrollReveal();
  return <section className="relative py-24 px-6 z-10 bg-night-800/30 border-y border-gold-500/10" data-id="element-112">
      <div className="max-w-5xl mx-auto" data-id="element-113">
        {/* The Unique Mechanism */}
        <div ref={methodRef} className={`mb-24 text-center section-reveal ${methodVisible ? 'visible' : ''}`} data-id="element-114">
          <h2 className="text-sm tracking-[0.2em] text-gold-400 uppercase mb-4 font-semibold" data-id="element-115">
            La Solución
          </h2>
          <h3 className="text-4xl md:text-5xl font-heading font-bold text-cream-100 mb-8" data-id="element-116">
            Presentamos el Método <span className="text-gold-500" data-id="element-117">S.C.A.</span>
          </h3>
          <div className="flex justify-center gap-4 md:gap-8 mb-10 font-heading text-xl md:text-2xl text-cream-200" data-id="element-118">
            <span className="flex flex-col items-center" data-id="element-119">
              <span className="text-gold-400 text-3xl mb-1" data-id="element-120">S</span>oltar
            </span>
            <span className="text-lavender-500/50 flex items-center" data-id="element-121">•</span>
            <span className="flex flex-col items-center" data-id="element-122">
              <span className="text-gold-400 text-3xl mb-1" data-id="element-123">C</span>almar
            </span>
            <span className="text-lavender-500/50 flex items-center" data-id="element-124">•</span>
            <span className="flex flex-col items-center" data-id="element-125">
              <span className="text-gold-400 text-3xl mb-1" data-id="element-126">A</span>gradecer
            </span>
          </div>
          <p className="text-lg md:text-xl text-cream-200 leading-relaxed max-w-3xl mx-auto" data-id="element-127">
            Es una secuencia operativa de 10 minutos que actúa como un{' '}
            <span className="text-gold-400 font-semibold" data-id="element-128">
              "interruptor biológico"
            </span>
            . En lugar de pelear con tu mente, usamos la neurociencia para bajar
            las revoluciones de tu sistema nervioso mecánicamente, forzando a tu
            cuerpo a entrar en el estado de reposo profundo.
          </p>
        </div>

        {/* What You Get */}
        <div ref={featuresRef} className={`section-reveal ${featuresVisible ? 'visible' : ''}`} data-id="element-129">
          <h3 className="text-3xl font-heading font-bold text-cream-100 mb-12 text-center" data-id="element-130">
            ¿Qué incluye el sistema?
          </h3>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-131">
            <div className="glass-card p-8 rounded-2xl hover:border-gold-500/30 transition-colors duration-300" data-id="element-132">
              <BookOpenIcon className="w-8 h-8 text-gold-400 mb-6" data-id="element-133" />
              <h4 className="text-xl font-heading font-semibold text-cream-100 mb-3" data-id="element-134">
                La Guía Paso a Paso
              </h4>
              <p className="text-cream-200/80" data-id="element-135">
                El ritual exacto de 10 minutos para "apagar" tu cerebro.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl hover:border-gold-500/30 transition-colors duration-300" data-id="element-136">
              <WindIcon className="w-8 h-8 text-gold-400 mb-6" data-id="element-137" />
              <h4 className="text-xl font-heading font-semibold text-cream-100 mb-3" data-id="element-138">
                Técnica de Respiración Lunar
              </h4>
              <p className="text-cream-200/80" data-id="element-139">
                El hack físico para frenar el ritmo cardíaco en segundos.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl hover:border-gold-500/30 transition-colors duration-300" data-id="element-140">
              <BrainIcon className="w-8 h-8 text-gold-400 mb-6" data-id="element-141" />
              <h4 className="text-xl font-heading font-semibold text-cream-100 mb-3" data-id="element-142">
                El Mapa del Vaciado Mental
              </h4>
              <p className="text-cream-200/80" data-id="element-143">
                Cómo sacar las preocupaciones de tu cabeza y dejarlas en el
                papel.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl hover:border-gold-500/30 transition-colors duration-300 md:col-span-1 lg:col-span-1 lg:col-start-2" data-id="element-144">
              <BedDoubleIcon className="w-8 h-8 text-gold-400 mb-6" data-id="element-145" />
              <h4 className="text-xl font-heading font-semibold text-cream-100 mb-3" data-id="element-146">
                Auditoría del Santuario
              </h4>
              <p className="text-cream-200/80" data-id="element-147">
                Pequeños ajustes en tu habitación que bloquean la alerta
                cerebral.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl hover:border-gold-500/30 transition-colors duration-300 md:col-span-2 lg:col-span-1" data-id="element-148">
              <PenLineIcon className="w-8 h-8 text-gold-400 mb-6" data-id="element-149" />
              <h4 className="text-xl font-heading font-semibold text-cream-100 mb-3" data-id="element-150">
                Plantilla de Diario Nocturno
              </h4>
              <p className="text-cream-200/80" data-id="element-151">
                Para que no tengas que pensar en qué escribir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}